/*
Ex: https://medium.com/@bolajifemi28/how-to-add-paypal-checkout-to-your-react-app-37d44c58a896

npm install — save react-async-script-loader

*/

import React from "react";
import ReactDOM from "react-dom";
import scriptLoader from "react-async-script-loader";
import { Spinner } from "reactstrap";
import { API } from "aws-amplify";
import { getRegistrationService } from "../../../ServiceNameMapper";

//var CLIENT_ID = "AbAQuikNYjLoVbUhMxDzWo-bqwYtqEOUNzEJLhZzffZrmEzZITEj4TMxCMjjTzgp2xFEPe3X4cdE32Zn&currency=USD"; //TEST
var CLIENT_ID = "AXQWgEyiwS9ezziI4LE8mkIESR9ZTVvOi3kYrIU6bH72S4yRFViDCs-qtWkulu8pnXEaMzESfo8hdk8J&currency=USD"; //LIVE

//create button here
let PayPalButton = null;

class PaypalSnawa extends React.Component {
    constructor(props) {
        super(props);

        var loginbuttonstyle = {};
        if(global.$registrationform.styles.login != null)
        {
            loginbuttonstyle = global.$registrationform.styles.login;
        }

        this.state = {
            code: global.$code,
            s3: global.$s3,
            bucket: global.$s3bucket,
            loginbuttonstyle: loginbuttonstyle,
            showButtons: false,
            loading: true,
            showsuccessmessage: false,
            paid: false, // LIVE
            //paid: true // TEST
        };

        window.React = React; //needed for the PayPal React Component which comes with the library
        window.ReactDOM = ReactDOM; // needed for the PayPal React Component which comes with the library
        
    }

    componentDidMount() {
        const { isScriptLoaded, isScriptLoadSucceed } = this.props;
       //console.log(isScriptLoaded, isScriptLoadSucceed);
        if (isScriptLoaded && isScriptLoadSucceed) {
            PayPalButton = window.paypal.Buttons.driver("react", { React, ReactDOM });
            this.setState({ loading: false, showButtons: true });
        }
    }

    componentWillReceiveProps(nextProps) {
        const { isScriptLoaded, isScriptLoadSucceed } = nextProps;

       //console.log(isScriptLoaded, isScriptLoadSucceed);
        const scriptJustLoaded =
            !this.state.showButtons && !this.props.isScriptLoaded && isScriptLoaded;
       //console.log(!this.state.showButtons, !this.props.isScriptLoaded, isScriptLoaded)
       //console.log(scriptJustLoaded);

        if (scriptJustLoaded) {
           //console.log("scriptJustLoaded")
            if (isScriptLoadSucceed) {
               //console.log("ScriptLoadSucceed")
                PayPalButton = window.paypal.Buttons.driver("react", {
                    React,
                    ReactDOM
                });
                this.setState({ loading: false, showButtons: true });
            }
        }
    }
    createOrder = (data, actions) => {
        
        //LIVE:COMMENT
        //console.log(global.$regamount, global.$attendeeregitems)

        var desc = `${this.props.itemname + " = "+this.props.fname + " " + this.props.lname + ", " + this.props.userid}`
        var amount = this.props.amount   // LIVE
        //var amount = 0.05                  // TEST

       //console.log(`Amount = ${this.props.amount}, desc = ${desc}`)
        var inputs = {
            
            intent: "CAPTURE",
            purchase_units: [
                {
                    description: desc,
                    amount: {
                        currency_code: "USD",
                        value:  amount
                    }
                }
            ]
        }
        //console.log(inputs);
        return actions.order.create(inputs);
    };

    onApprove = (data, actions) => {
        actions.order.capture().then(details => {
            const paymentData = {
                payerID: data.payerID,
                orderID: data.orderID
            };

           //console.log("Payment Approved: ", paymentData);

            this.setState({ showButtons: false, paid: true });
        });
    };

    render() {
        const { showButtons, loading, paid } = this.state;
       //console.log(this.state.showsuccessmessage);
        return (
            <div className="main">
                {loading && <Spinner />}

                {showButtons && (
                    <div className="payment-div">
                        <div className="payment-summary-div">
                            <br/>
                            <p className="payment-amount">Total Amount = ${this.props.amount}</p>
                        </div>
                        <PayPalButton
                            createOrder={(data, actions) => this.createOrder(data, actions)}
                            onApprove={(data, actions) => this.onApprove(data, actions)}
                        />
                    </div>
                )}

                {paid && (
                    <div className="main">
                        {
                            this.state.showsuccessmessage == true ?
                            (
                                <p className="payment-success" style={{margin: "10px"}}>Successfully paid.</p>
                            )
                            :
                            (
                                this.state.showsuccessmessage == false ?
                                (

                                    this.recordPurchaseAndSendEmail()
                                )
                                :
                                ('')
                            )
                        }
                    </div>
                )}
            </div>
        );
    }

    recordPurchaseAndSendEmail() {
        let apiName = getRegistrationService();
        let path = ''; //replace this with the path you have configured on your API
        var date = new Date();
        var longFormat = date / 1000;
        this.setState({showsuccessmessage: "inprogress"});
        let myInit =
        {
            body:
            {
                'code': global.$code,
                'command': 'recordPurchaseAndEmail',
                'userid': this.props.userid,
                'fname': this.props.fname,
                'lname': this.props.lname,
                'itemnames': this.props.itemname,
                'amount': this.props.amount.toString(),
                'orderid': ' ',
                'paymentid': ' ',
                'signature': ' ',
                'email': this.props.userid,
                'phone': ' ',
                'description': ' ',
                'paymenttype': 'Paypal',
                'purchasedate': longFormat.toString(),
                'templatekey': 'auctionemail',
                'totalamount': this.props.amount.toString(),
                'paymentstatus': 'paid'
            },
            response: true,
            convertEmptyValues: true,
            headers: {}
        }
       //console.log(myInit);
        API.post(apiName, path, myInit).then(response => {
           //console.log(response)
            if (response.err == null) {
                this.setState({showsuccessmessage: true})
            }
            else {
            }

        }).catch(error => {
            ////console.log(error.response)
        });
    }    

}
export default scriptLoader(`https://www.paypal.com/sdk/js?client-id=${CLIENT_ID}`)(PaypalSnawa);